import { NodeReadingData } from '@/contexts/RealtimeDataContext';
import { ChartDataPoint, ChartInfo, ChartUtilResult } from '@/components/General/PlayerChart';

export function transformNodeData(nodeData: NodeReadingData, paramId?: string): ChartUtilResult {
	const effectiveParamId = paramId ?? nodeData.paremeterId;

	if (!nodeData.readings) {
		return {
			info: {
				name: `${nodeData.infrastructureName} ${nodeData.nodeName}`,
				valueUnit: nodeData.valueUnit,
			},
			data: [],
			paramId: effectiveParamId,
		};
	}

	const data: ChartDataPoint[] = Object.entries(nodeData.readings)
		.map(([timestampStr, reading]) => {
			const timestamp = parseInt(timestampStr, 10);

			return {
				x: timestamp,
				y: reading.v
			};
		})
		.sort((a, b) => a.x - b.x);

	const info: ChartInfo = {
		name: `${nodeData.infrastructureName} ${nodeData.nodeName}`,
		valueUnit: nodeData.valueUnit,
	};

	return {
		info,
		data,
		paramId: effectiveParamId,
	};
}

export function transformMultipleNodes(nodesData: NodeReadingData[]): ChartUtilResult[] {
	return nodesData.map((nodeData) => transformNodeData(nodeData));
}
